<template>
  <main class="form-signin">
    <form>
      <img class="mb-4" src="../assets/img/logo.png" alt="Logo" width="200" height="110" /><br />
      <h5 style="margin-bottom:30px;">PASSWORD RESET</h5>
      <p>Password must be at least 8 characters long, 1 uppercase, 1 lowercase character, 1 symbol &amp; 1 number. </p>
      <div class="input-group mb-3">
        <input
          :type="showPassword ? 'text' : 'password'"
          class="form-control"
          id="newPassword"
          placeholder="Password"
          v-model="user.password"
        />
        <span class="input-group-text">
          <i
            :class="showPassword ? 'far fa-eye-slash' : 'far fa-eye'"
            id="togglePassword"
            style="cursor: pointer"
            @click="togglePasswordField"
          ></i>
        </span>
      </div>

      <div class="input-group mb-3">
        <input
          :type="showConfirmPassword ? 'text' : 'password'"
          class="form-control"
          id="confirmPassword"
          placeholder="Confirm Password"
          v-model="user.confirmPassword"
        />
        <span class="input-group-text">
          <i
            :class="showConfirmPassword ? 'far fa-eye-slash' : 'far fa-eye'"
            id="togglePassword"
            style="cursor: pointer"
            @click="toggleConfirmPasswordField"
          ></i>
        </span>
      </div>
      <button class="w-100 btn btn-lg btn-primary" type="button" @click="saveNewPassword">Save</button>
      <p class="mt-5 mb-3 text-muted">&copy; GOFAR</p>
    </form>
  </main>
</template>

<script>
import { apiClient } from '../helpers/api-client';
import { HTTP_STATUS_CODES } from '../helpers/config';
import Swal from 'sweetalert2';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      user: {
        password: '',
        confirmPassword: ''
      },
      showPassword: false,
      showConfirmPassword: false
    };
  },
  methods: {
    togglePasswordField() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPasswordField() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    async saveNewPassword() {

      if (this.user.password !== this.user.confirmPassword) {
        Swal.fire({
          icon: 'error',
          title: 'Password Reset Failed!',
          text: `Passwords do not match, please try again!`,
          footer: ''
        });
        return;
      }
      try {
        localStorage.setItem('access_token', this.$route.query.access_token);
        const res = await apiClient(
          `/users/reset-password?access_token=${this.$route.query.access_token}`,
          'POST',
          {
            password: this.user.password,
            confirmation: this.user.confirmPassword
          },
          { redirectOnUnauthorized: false }
        );
        switch (res.status) {
          case HTTP_STATUS_CODES.NO_CONTENT:
            Swal.fire({
              icon: 'success',
              title: 'Password Changed!',
              text: `Your password has been successfully changed. Please login to your GOFAR app with your new password.`,
              footer: `Go to your mobile app and log in!`
            });
            break;
          case HTTP_STATUS_CODES.UNPROCESSABLE_ENTITY:
            Swal.fire({
              icon: 'error',
              title: `We couldn't change your password at this time!`,
              text: `${res.data.error.message}`,
              footer: ``
            });
            break;
          default:
            Swal.fire({
              icon: 'error',
              title: `We couldn't change your password at this time!`,
              text: `Your password reset failed, this is most likely due to your password reset link expiring. Please go to your GOFAR app and try the password reset process again. Please contact us at support@gofar.co if problems persist.`,
              footer: ''
            });
            break;
        }
      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: `We couldn't change your password at this time.!`,
          text: `Your password reset failed, this is most likely due to your password reset link expiring. Please go to your GOFAR app and try the password reset process again. Please contact us at support@gofar.co if problems persist.`,
          footer: ''
        });
      }
    }
  }
};
</script>

<style scoped>
.form-signin {
  max-width: 350px;
  padding: 15px;
  margin: auto;
}
</style>
